import { RESET_ASSIGN_USER_FORM } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default () => creditFileActions[RESET_ASSIGN_USER_FORM]();
